import React from 'react';
import { FormGroup, Input, Label } from '../../../../components/Bootstrap';

type AddingCustomFormGroupProps = {
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

export const AddingCustomFormGroup: React.FC<AddingCustomFormGroupProps> = ({ name, value, onChange }) => {
  return (
    <FormGroup>
      <Label for='option'>{`${name} Name`}</Label>
      <Input value={value} onChange={onChange} name='name' id='name' placeholder='' />
    </FormGroup>
  );
};
